import React from "react";

const Image = ({ src, alt, className}) => {
  // Handle image error by showing a fallback image
 

  return (
    <img
      src={src} // Use src if provided, otherwise fallbackSrc
      alt={alt || "Image"} 
      className={className}// Default alt tex
    />
  );
};

export default Image;
